<template>
  <div class="comment">
      <div class="post-comment-input">
        <div>
          <img v-if="head && user" :src="getPhoto(user)"/>
          <textarea :style="{width: head && user ? 'calc(100% - 53px)': '100%'}" @focus="textAreaFocus = true" @blur="textAreaFocus = false" :placeholder="placeholder" v-model="content" rows="3" />
        </div>
         <el-collapse-transition>
          <div v-show="textAreaFocus">
            <span class="post-comment-btn" @click="cancel">取消</span><span :style="{opacity: content ? 1: 0.3}" @click="confirm">发送</span>
          </div>
         </el-collapse-transition>
      </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'comment',
  data () {
    return {
      content: '',
      placeholder: '写下你的评论...',
      textAreaFocus: false,
    }
  },
  props: {
    head: { // 是否显示头像
      type: Boolean,
      default: true
    },
    commentListIndex: { // 针对第几条评论进行的评论
      type: String,
      default: '0', // 默认针对文章作者进行评论
    },
    toUserId: { // 被评论的用户uid
      type: String
    },
    toUserName: { // 被评论的用户昵称
      type: String
    }
  },
  computed: {
    ...mapGetters('home', ['user']),
    ...mapGetters("post", ["post"])
  },
  methods: {
    ...mapActions('post', ['commentPost']),
    cancel () {
      this.content = ''
      this.$emit('cancel')
    },
    async confirm () {
      if(!this.user) {
        this.isLogin('登录后评论')
        return
      }
      if(!this.content) return
      await this.commentPost({
        _id: this.post.post.id,
        toUserId: this.toUserId,
        content: this.content,
        commentListIndex: this.commentListIndex
      })
      this.$message({
        message: '评论成功',
        type: 'success'
      })
      this.content = ''
      this.textAreaFocus = false
      this.$emit('cancel')
    }
  },
  created () {
    if(this.toUserName) {
      this.placeholder = `回复 ${this.toUserName} :`
    }
  }
}
</script>
<style lang="scss" scoped>
.comment {
  >.post-comment-input {
    >:first-child {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      >img{
        width: 43px;
        height: 43px;
        border-radius: 50%;
      }
      textarea {
        background:rgba(248,248,248,1);
        border-radius:6px;
        border: none;
        resize:none;
        outline: none;
        padding: 17px;
        font-size:14px;
        color:rgba(51,51,51,1);
        line-height:24px;
        border:1px solid rgba(234,234,234,1);
      }
    }
    >:nth-child(2) {
      display: flex;
      justify-content: flex-end;
      margin-top: 21px;
      >span{
        display: inline-block;
        height:38px;
        line-height: 38px;
        padding: 0 24px;
        font-size:16px;
        font-family:MicrosoftYaHei;
        color:rgba(153,153,153,1);
         &:hover {
            cursor: pointer;
          }
      }
      >:nth-child(2){
        background:rgba(66,192,46,1);
        border-radius:19px;
        font-size:16px;
        font-family:MicrosoftYaHei-Bold;
        font-weight:bold;
        color:rgba(255,255,255,1);
        margin-left: 10px;
      }
    }
  }
}
</style>


